<template>
  <div class="sideBar-container filterBar-skeleton-container">
    <div class="side-nav-container w-100 filter-skeleton">
      <div class="side-nav bg-white w-100">
        <div class="side-nav-inner p-0 p-xl-3">
          <div class="sideBar-header side-nav-title skeleton-header">
            <div class="d-flex align-items-center justify-content-between w-100 mb-1">
              <div class="d-flex align-items-center gap-2">
                <Skeleton class="d-block d-xl-none" width="28px" height="28px" borderRadius="8px" />
                <Skeleton width="72px" height="22px" />
                <Skeleton width="32px" height="22px" />
              </div>
              <div class="d-flex align-items-center gap-2">
                <Skeleton class="d-none d-xl-block" width="78px" height="22px" borderRadius="6px" />
                <Skeleton class="d-block d-xl-none" width="132px" height="34px" borderRadius="18px" />
              </div>
            </div>
          </div>

          <div class="px-3 mt-3 d-block d-xl-none">
            <Skeleton width="60%" height="16px" class="mb-2" />
            <div class="d-flex flex-row pt-1 overflow-auto gap-2">
              <Skeleton v-for="n in 4" :key="`mobile-chip-${n}`" width="120px" height="32px" borderRadius="16px" />
            </div>
          </div>

          <div class="my-3 my-xl-0 sideBar-body pb-64 pb-xl-11 px-3 px-xl-0">
            <div class="location-block d-flex justify-content-between align-items-center pb-4">
              <div class="d-flex align-items-center gap-2 flex-grow-1">
                <Skeleton width="16px" height="16px" borderRadius="50%" />
                <Skeleton width="100px" height="16px" />
              </div>
              <Skeleton width="96px" height="22px" borderRadius="6px" />
            </div>   

            <div
              class="mb-12 multi-select border-0"
              v-for="label in selectPlaceholders"
              :key="label"
            >
              <Skeleton width="30%" height="14px" class="mb-2" />
              <Skeleton height="44px" class="w-100" borderRadius="12px" />
            </div>

            <div class="panel-separator"></div>

            <div
              v-for="panel in panelSections"
              :key="panel.title"
              class="panel-skeleton"
              :class="{ 'with-separator': panel.title !== 'Couleur exterieure' }"
            >
              <div class="d-flex justify-content-between align-items-center mb-3">
                <Skeleton width="55%" height="16px" />
                <Skeleton width="18px" height="18px" />
              </div>

              <div v-if="panel.type === 'double'" class="d-flex gap-2 mb-1">
                <Skeleton height="44px" class="w-50" borderRadius="12px" />
                <Skeleton height="44px" class="w-50" borderRadius="12px" />
              </div>

              <div v-else-if="panel.type === 'checkbox'" class="d-flex flex-column gap-2">
                <div
                  v-for="n in panel.count"
                  :key="`${panel.title}-check-${n}`"
                  class="d-flex align-items-center gap-2"
                >
                  <Skeleton width="18px" height="18px" borderRadius="6px" />
                  <Skeleton width="70%" height="14px" />
                </div>
              </div>

              <div v-else-if="panel.type === 'chips'" class="d-flex flex-wrap gap-2">
                <Skeleton
                  v-for="n in panel.count"
                  :key="`${panel.title}-chip-${n}`"
                  width="72px"
                  height="28px"
                  borderRadius="14px"
                />
              </div>

              <div v-else-if="panel.type === 'colors'" class="row row-cols-2 g-3">
                <div v-for="n in 6" :key="`color-${n}`" class="col">
                  <Skeleton height="44px" class="w-100" borderRadius="12px" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sideBar-footer d-xl-none">
          <Skeleton width="100%" height="44px" borderRadius="8px" />
        </div>
      </div>
    </div>
    <div class="d-none d-xl-block bottom-0 bg-white p-3 btn-result">
      <Skeleton width="100%" height="44px" borderRadius="8px" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";

const selectPlaceholders = ["Marque", "Modele", "Finition"];
const panelSections = [
  { title: "Type de carrosserie", type: "checkbox", count: 4 },
  { title: "Prix", type: "double" },
  { title: "Kilométrage", type: "double" },
  { title: "Annee", type: "double" },
  { title: "Carburant", type: "checkbox", count: 3 },
  { title: "Boite", type: "checkbox", count: 2 },
  { title: "Nombre de places", type: "chips", count: 5 },
  { title: "Couleur exterieure", type: "colors" },
];
</script>

<style scoped lang="scss">
@import "~/assets/styles/_mixins.scss";

.filter-skeleton {
  position: relative;
  z-index: 1;
}

.filterBar-skeleton-container {
  display: none;

  @include screen-laptop-above-xl {
    display: block;
  }
}

.side-nav {
  width: 100%;

  @include screen-laptop-above-xl {
    width: 264px;
  }
}

.side-nav-inner {
  padding: 16px;
}

.location-block {
  gap: 8px;
}

.panel-separator {
  border-top: 1px solid #f1f2f4;
  margin: 4px 0 12px;
}

.panel-skeleton {
  padding: 12px 0;

  &.with-separator {
    border-bottom: 1px solid #f1f2f4;
    margin-bottom: 12px;
  }
}

.sideBar-footer {
  padding: 0 16px 16px;
}

.btn-result {
  position: sticky;
  box-shadow: 0 -1px 4px 0 var(--colors-elevation-1, rgba(109, 109, 131, 0.25));
}
</style>
